import {Navigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';

const Index = () => {
  const landingPage = useSelector(
    (state: RootState) => state.authenticatedUser.user?.landingPage
  );
  return <Navigate to={landingPage || '/'} replace />;
};

export default Index;
